import type {
  OutsideRentMonthLeaseItem,
  OutsideRentMonthLeasesResult,
} from "~/types/finance";
import { formatDisplayDateOnly } from "~/utils/date";

export function emptyOutsideRentMonthLeasesResult(): OutsideRentMonthLeasesResult {
  return {
    items: [],
    counts: {
      startsAfterMonth: 0,
      endedBeforeMonth: 0,
      nonActive: 0,
      total: 0,
    },
  };
}

export function getOutsideRentMonthTenantDisplayName(
  record: OutsideRentMonthLeaseItem,
): string {
  const first = record.tenant?.firstName?.trim() ?? "";
  const last = record.tenant?.lastName?.trim() ?? "";
  const name = `${first} ${last}`.trim();
  return name || record.tenant?.id || "-";
}

function formatLeaseDisplayDate(value: string | undefined): string {
  if (!value) return "-";
  return formatDisplayDateOnly(value, "dateWithDay") || "-";
}

export function formatOutsideRentMonthLeaseDateRange(
  record: OutsideRentMonthLeaseItem,
): string {
  const start = formatLeaseDisplayDate(record.startDate);
  const end = formatLeaseDisplayDate(record.endDate);
  return `${start} → ${end}`;
}
